<div mat-dialog-title>
  <h4 class="d-flex flex-row justify-content-between">
    <span> {{'g.comments'|translate}}</span>
  </h4>
  <hr>
</div>


<div mat-dialog-content>
  <div class="d-flex flex-column">
    <div class="pb-2">
      <span>{{'g.comments.rating'|translate}}</span>
      <button mat-icon-button [ngClass]="{'ke-color-primary': tnt_rating>=(i+1)}"
        *ngFor="let ratingId of ratingArr;index as i" (click)="onClick(i+1)" [matTooltip]="ratingId+1"
        matTooltipPosition="above">
        <mat-icon>
          {{showIcon(i)}}
        </mat-icon>
      </button>
    </div>
    <span>1. {{'g.comments.result'|translate}}</span>
    <mat-radio-group [(ngModel)]="tnt_vote_result" class="pb-2">
      <mat-radio-button value="Excellent" class="pr-2">{{"g.comments.result.1"|translate}}</mat-radio-button>
      <mat-radio-button value="Fair" class="pr-2">{{"g.comments.result.2"|translate}}</mat-radio-button>
      <mat-radio-button value="Poor" class="pr-2">{{"g.comments.result.3"|translate}}</mat-radio-button>
    </mat-radio-group>

    <span>2. {{'g.comments.performance'|translate}}</span>
    <mat-radio-group [(ngModel)]="tnt_performance" class="pb-2">
      <mat-radio-button value="Fast" class="pr-2">{{"g.comments.performance.1"|translate}}</mat-radio-button>
      <mat-radio-button value="Medium" class="pr-2">{{"g.comments.performance.2"|translate}}</mat-radio-button>
      <mat-radio-button value="Slow" class="pr-2">{{"g.comments.performance.3"|translate}}</mat-radio-button>
    </mat-radio-group>


    <mat-form-field>
      <mat-label>{{'g.comments.remark'|translate}}</mat-label>
      <textarea matInput type="text" [(ngModel)]="tnt_reason" matAutosize></textarea>
      <!-- <mat-hint>{{'g.coments.remark.hint'|translate}}</mat-hint> -->
    </mat-form-field>
  </div>
</div>


<div mat-dialog-actions class="d-flex flex-row justify-content-center">
  <button class="ke-btn-outline mr-3 align-items-center" style="padding: 3px 20px;background-color: white;"
    type="button" (click)="Back(false)">
    <span class="pl-1 ke-font-button">{{'g.close'|translate}}</span>
  </button>
  <button class="ke-btn-primary  align-items-center" style="padding: 3px 20px;" type="button" (click)="Back(true)">
    <span class="pl-1 ke-font-button">{{'g.comments.submit'|translate}}</span>
  </button>


</div>
